module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dialog-container"
  }, [_c('el-dialog', {
    class: _vm.classes,
    attrs: {
      "title": _vm.title,
      "visible": _vm.visible,
      "modal-append-to-body": false,
      "append-to-body": true,
      "close-on-click-modal": false,
      "modal": _vm.modal,
      "width": _vm.width,
      "show": _vm.show
    },
    on: {
      "update:visible": function($event) {
        _vm.visible = $event
      },
      "close": _vm.closePop
    }
  }, [_vm._t("default"), _vm._v(" "), _vm._t("shoucang"), _vm._v(" "), _vm._t("shoucang-btn")], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-47af340e","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/common/pops/pop.vue
// module id = 561
// module chunks = 1 2 3 4 5 6 7 8